<template>
    <el-row class="box">
        <el-row type="flex" class="row-bg-top header" justify="center">
            <el-col :span="17" class='content'>
                <el-row class=" head_top" > 
                    <el-col :span="12" class='head_top_left'>  
                         <a href="http://www.jssyyjxh.com" class="head-title">江苏省音乐家协会欢迎您</a>         
                    </el-col>  
                      
                    <!-- <el-col :span="9" class='search'>  
                       <div class="flex_cc search_info">
                            <input type="text" class='input'><input type="submit" value='搜索' class='searchBtn'>
                       </div>
                    </el-col> -->
                    <el-col :span="12" class='top_login'>  
                        <a class='cor' @click='()=>{this.$router.push({name:"indexRegister"})}'>注册</a> 
                        | <a class='cor' @click='()=>{this.$router.push({name:"message"})}'>登录</a>     
                    </el-col>
                </el-row>    
            </el-col>
        </el-row>
        <!-- <div class="main">
            <p class='box_footer'>省音协考级报名咨询电话  025-83572077</p>
        </div> -->
    </el-row>    
</template>
<script>
// import personaldataVue from '@/views/PersonalData'
export default { 
//     components:{
//     registerVue
//   },
data(){
    return{

    }
},
  created(){
    //   window.Global.getLocalStorage('token')
    //   console.log(window.Global.getLocalStorage('token'))
    //   console.log(this.$route.path)
  },
  methods: {

  }
}
</script>
<style lang="less">
@import '../../static/less/bg.less';

</style>


   


// WEBPACK FOOTER //
// src/components/Background.vue